export default __webpack_public_path__ + "static/media/card-img4.af2393e5.png";